export const namespaced = true;

export const state = {
  show: 0,
};
